module.exports = __webpack_public_path__ + "img/antes_despues_94.789c1cb5.png";